import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, useOutletContext, useSearchParams } from 'react-router-dom';
import { Card } from "../../common_components/Layout";
import { TitleAndText } from "../components/TitleAndText";
import { PrimaryButton } from "../../common_components/Buttons";
import CreateMissionHeaderAndTitleRow from "../components/CreateMissionHeaderAndTitleRow";


import { useAlert } from 'react-alert'


function InvoiceConfirmation(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()



    return (
        <div className="create-mission-primary-content-container">
            <CreateMissionHeaderAndTitleRow title="Project Launched!" subtitle="Your project has been launched. Contact us at info@despark.io with any questions or concerns." hidePrice={true} />
            <PrimaryButton onClick={() => navigate("/dashboard")} text="Back to Dashboard" />
        </div>


    )
}

export default InvoiceConfirmation;